import axios from "axios";
let commonHeaders = {};

console.log(commonHeaders);
axios.interceptors.request.use((config) => {
  for (var i in commonHeaders) {
    config.headers[i] = commonHeaders[i];
  }
  return config;
});

function setResHeader(header) {
  commonHeaders = header;
}

function getHeader() {
  return commonHeaders;
}

function setContentType(contentType) {
  commonHeaders["Content-Type"] = contentType;
}

function expandHeader(expHeader) {
  Object.assign(commonHeaders, expHeader);
}

export { axios, setResHeader, getHeader, setContentType, expandHeader };
